import { ExternalLinkIcon } from 'lucide-react';
import { ComponentProps } from 'react';

export const LinkToExternal = ({ children, ...props }: ComponentProps<'a'>) => {
  return (
    <a rel="noopener noreferrer" target="_blank" {...props}>
      <span className="flex gap-x-1 items-center">
        {children}
        <ExternalLinkIcon className="w-4 h-4" />
      </span>
    </a>
  );
};
